"use strict";

import { from, of, take } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import {
    mergeMap,
    catchError,
    map,
    concatMap,
    merge,
    takeUntil,
} from "rxjs/operators";

import {
    ajaxError,
    knowledgeLatestQuizzesComplete,
    knowledgeDashboardComplete,
    participantQuizzesComplete,
    quizzDetailsComplete,
    anwerQuestionComplete,
    enrolQuizzComplete,
    questionResultComplete,
} from "../_actions";
import {
    knowledgeConstants,
    requestTypes,
    authConstants,
    commonConstants,
} from "../_constants";
import { getRequestHeader } from "../../_helpers/request.header";

export const getKnowlegeLatestQuizzesEpic = (actions$) => {
    return actions$.pipe(
        ofType(knowledgeConstants.KNOWLEDGE_LATEST_QUIZZES_REQUEST),
        mergeMap((action) =>
            ajax
                .get(
                    "/api/knowledge/latest-quizzes",
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return knowledgeLatestQuizzesComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const getKnowlegeDasboardEpic = (actions$) => {
    return actions$.pipe(
        ofType(knowledgeConstants.KNOWLEDGE_DASHBOARD_REQUEST),
        mergeMap((action) =>
            ajax
                .get(
                    "/api/knowledge/knowledge-dashboard",
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return knowledgeDashboardComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const getKnowlegeParticipantQuizzesEpic = (actions$) => {
    return actions$.pipe(
        ofType(knowledgeConstants.KNOWLEDGE_PARTICIPANT_QUIZZES_REQUEST),
        mergeMap((action) =>
            ajax
                .get(
                    "/api/knowledge/participant-quizzers",
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return participantQuizzesComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const getKnowlegeQuizzDetailsEpic = (actions$) => {
    return actions$.pipe(
        ofType(knowledgeConstants.KNOWLEDGE_QUIZZE_DETAILS_REQUEST),
        mergeMap((action) =>
            ajax
                .get(
                    "/api/knowledge/quizz-details/" + action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return quizzDetailsComplete(ajaxResponse.response);
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const knowlegeAnswerQuestionEpic = (actions$) => {
    return actions$.pipe(
        ofType(knowledgeConstants.KNOWLEDGE_ANSWER_QUESTION_REQUEST),
        mergeMap((action) => {
            const { nextStep, ...payload } = action.payload;

            return ajax
                .post(
                    "/api/knowledge/answer-question",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        nextStep();
                        return anwerQuestionComplete(ajaxResponse.response);
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const knowlegeEnrolQuizzEpic = (actions$) => {
    return actions$.pipe(
        ofType(knowledgeConstants.KNOWLEDGE_ENROL_QUIZZE_REQUEST),
        mergeMap((action) => {
            const { goToStep, nextQuestionId, numberOfAttempts, ...payload } =
                action.payload;

            return ajax
                .get(
                    "/api/knowledge/enrol-quizz/" + payload.id,
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        if ((numberOfAttempts != 0)) {
                            goToStep(nextQuestionId);
                        }
                        return enrolQuizzComplete(ajaxResponse.response);
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const knowlegeQuestioResultEpic = (actions$) => {
    return actions$.pipe(
        ofType(knowledgeConstants.KNOWLEDGE_QUESTION_RESULT_REQUEST),
        mergeMap((action) =>
            ajax
                .get(
                    "/api/knowledge/quizz-results/" + action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return questionResultComplete(ajaxResponse.response);
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};
